// tslint:disable: no-inferrable-types
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormField } from '../lib/form-field.model';
import { FormPermission } from '../lib/form-permission.model';

export interface WorkflowFormFieldItemPermissionEvent {
  bulk: boolean;
  id: string;
  editable?: boolean;
}

@Component({
    selector: 'eas-workflow-form-field-item',
    templateUrl: './form-field-item.component.html',
    styleUrls: ['./form-field-item.component.css'],
    standalone: false
})
export class WorkflowFormFieldItemComponent {

  @Input() item!: FormField;
  @Input() permission?: FormPermission;
  @Input() canChangePermission: boolean = false;
  @Input() isFirst: boolean = false;
  @Input() isLast: boolean = false;
  @Output() editField = new EventEmitter<string>();
  @Output() setPermission = new EventEmitter<WorkflowFormFieldItemPermissionEvent>();
  @Output() removePermission = new EventEmitter<WorkflowFormFieldItemPermissionEvent>();
  @Output() moveFieldUp = new EventEmitter<string>();
  @Output() moveFieldDown = new EventEmitter<string>();

  constructor() {}

  //
  // Actions
  //

  public onEdit(): void {
    this.editField.emit(this.item.id);
  }

  public onSetPermission(isEditable: boolean, isBulk: boolean): void {
    this.setPermission.emit({id: this.item.id, editable: isEditable, bulk: isBulk});
  }

  public onRemovePermission(isBulk: boolean): void {
    this.removePermission.emit({id: this.item.id, bulk: isBulk});
  }

  public onMoveUp(): void {
    this.moveFieldUp.emit(this.item.id);
  }

  public onMoveDown(): void {
    this.moveFieldDown.emit(this.item.id);
  }

  //
  // Template helpers
  //

  public get isEditable(): boolean {
    if (!this.permission) { return false; }
    return this.permission.editable;
  }

  public get hasPermission(): boolean {
    return this.permission !== undefined;
  }

  public get isStatusBarVisible(): boolean {
    return this.hasPermission || this.item.type.isInvalid;
  }

  public statusBarStateClass(): string {
    if (this.item.type.isInvalid) { return 'invalid'; }
    return this.isEditable ? 'editable' : 'visible';
  }

  public canBeAssignedChangedToReadOnly(): boolean {
    return !this.hasPermission || this.isEditable;
  }

  public canBeAssignedChangedToEditable(): boolean {
    return this.item.type.isUserEditable && (!this.hasPermission || !this.isEditable);
  }

  getRequiredOrOptional() {
    return this.item.required ? $localize `Required` : $localize `Optional`;
  }

  getAssignAsOrChangeToEditable() {
    return !this.hasPermission ? $localize `Assign as Editable` : $localize `Change to Editable`;
  }

  getAssignAsOrChangeToReadOnly() {
    return !this.hasPermission ? $localize `Assign as Read-only` : $localize `Change to Read-only`;
  }
}
